// extracted by mini-css-extract-plugin
module.exports = {"logo":"ForgotPasswordOTP_logo__3_qnv","message":"ForgotPasswordOTP_message__28Ikr"};